import { EdgeType, EdgeType as EntityEdgeType } from "@/managers/EntityManager";
import { EdgeType as DependencyEdgeType } from "@/interfaces/entities/EdgeType";

const entityToDependencyMap: Record<EntityEdgeType, DependencyEdgeType | undefined> = {
  [EntityEdgeType.SERVICE_TO_FUNCTION]: DependencyEdgeType.SERVICE_TO_FUNCTION,
  [EntityEdgeType.FUNCTION_TO_SERVICE]: undefined,
  [EntityEdgeType.ENDPOINT_TO_FUNCTION]: DependencyEdgeType.ENDPOINT_TO_FUNCTION,
  [EntityEdgeType.ENDPOINT_TO_MIDDLEWARE]: DependencyEdgeType.ENDPOINT_TO_MIDDLEWARE,
  [EntityEdgeType.MIDDLEWARE_TO_SERVICE]: DependencyEdgeType.MIDDLEWARE_TO_SERVICE,
  [EntityEdgeType.SERVICE_TO_SERVICE]: DependencyEdgeType.SERVICE_TO_SERVICE,
  [EntityEdgeType.FUNCTION_TO_FUNCTION]: undefined,
  [EntityEdgeType.MODEL_TO_ENDPOINT]: DependencyEdgeType.ENDPOINT_TO_MODEL,
  [EntityEdgeType.MODEL_TO_SERVICE]: DependencyEdgeType.SERVICE_TO_MODEL,
  [EdgeType.MIDDLEWARE_TO_FUNCTION]: DependencyEdgeType.MIDDLEWARE_TO_FUNCTION,
  [EdgeType.ENDPOINT_TO_SERVICE]: DependencyEdgeType.ENDPOINT_TO_SERVICE,
  [EdgeType.ENDPOINT_TO_MODEL]: DependencyEdgeType.ENDPOINT_TO_MODEL
};

const dependencyToEntityMap: Record<DependencyEdgeType, EntityEdgeType | undefined> = {
  [DependencyEdgeType.SERVICE_TO_FUNCTION]: EntityEdgeType.SERVICE_TO_FUNCTION,
  [DependencyEdgeType.SERVICE_TO_SERVICE]: EntityEdgeType.SERVICE_TO_SERVICE,
  [DependencyEdgeType.SERVICE_TO_MODEL]: EntityEdgeType.MODEL_TO_SERVICE,
  [DependencyEdgeType.MIDDLEWARE_TO_FUNCTION]: undefined,
  [DependencyEdgeType.MIDDLEWARE_TO_SERVICE]: EntityEdgeType.MIDDLEWARE_TO_SERVICE,
  [DependencyEdgeType.MIDDLEWARE_TO_MODEL]: EntityEdgeType.MODEL_TO_SERVICE,
  [DependencyEdgeType.ENDPOINT_TO_FUNCTION]: EntityEdgeType.ENDPOINT_TO_FUNCTION,
  [DependencyEdgeType.ENDPOINT_TO_MIDDLEWARE]: EntityEdgeType.ENDPOINT_TO_MIDDLEWARE,
  [DependencyEdgeType.ENDPOINT_TO_SERVICE]: undefined,
  [DependencyEdgeType.ENDPOINT_TO_MODEL]: EntityEdgeType.MODEL_TO_ENDPOINT,
  [DependencyEdgeType.MODEL_TO_MODEL]: EntityEdgeType.MODEL_TO_ENDPOINT,
};

export function mapEntityEdgeTypeToDependency(
  edgeType: EntityEdgeType
): DependencyEdgeType | undefined {
  return entityToDependencyMap[edgeType];
}

export function mapDependencyEdgeTypeToEntity(
  edgeType?: DependencyEdgeType
): EntityEdgeType | undefined {
  if (!edgeType) return undefined;
  return dependencyToEntityMap[edgeType];
}

